import AccountMain from "@/components/dashboard/account/AccountMain";
import MyCardModal from "@/components/dashboard/modal/MyCardModal";

export default function Account() {
  return (
    <>
      {/* My Card Modal */}
      <MyCardModal />

      {/* Account Main */}
      <AccountMain />
    </>
  );
}
